/**
 * Returns a valid authorization header string.
 */
function getAuthorizationHeader(clientInfo, deviceInfo, accessToken = '') {
    return [
        `MediaBrowser Client="${encodeURIComponent(clientInfo.name)}"`,
        `Device="${encodeURIComponent(deviceInfo.name)}"`,
        `DeviceId="${encodeURIComponent(deviceInfo.id)}"`,
        `Version="${encodeURIComponent(clientInfo.version)}"`,
        `Token="${encodeURIComponent(accessToken)}"`
    ].join(', ');
}

export { getAuthorizationHeader };
